import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef } from '@angular/core';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { EducationService } from '../../services/education.service';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, ValidationErrors, FormControl, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { PrintService } from '../../services/print.service'

@Component({
	selector: 'app-voucher-report',
	templateUrl: './voucher-report.component.html',
	styleUrls: ['./voucher-report.component.scss']
})
export class VoucherReportComponent implements OnInit{
	color: any = 'blue';
	@ViewChild('print_table', { static: false }) printtablepdf: ElementRef;
	programs: any = [];
	searchForm: UntypedFormGroup;
	reportResults: any = [];
	sending: any = false;
	loading: any = false;
	totals: any = [];
	sortedReportResults: any = [];
	sortByColumn: string;
	sortDirection: string;
	
	constructor(private _changeDetectorRef: ChangeDetectorRef, private fb: UntypedFormBuilder, private educationService: EducationService, private globalSearchService: GlobalSearchService,  private printService: PrintService) {
		this.color = this.globalSearchService.getColor();
		
	}
	
	ngOnInit(){
		this.educationService.getRewards().subscribe((r) => {
			this.programs = r;
		});
		this.searchForm = this.fb.group({
			'voucher': [],
			'startdate': ['', Validators.required],
			'enddate':['', Validators.required],
		});
	}
	
	sortBy(property: string): void {
		if (this.sortByColumn === property) {
			// Toggle sort direction if the same column is clicked
			this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
		} else {
			// Default to ascending order when a new column is clicked
			this.sortDirection = 'asc';
			this.sortByColumn = property;
		}

		this.sortedReportResults.sort((a, b) => {
			// Check if the property values are numeric
			const isNumeric = !isNaN(parseFloat(a[property])) && isFinite(a[property]) && !isNaN(parseFloat(b[property])) && isFinite(b[property]);

			if (isNumeric) {
				// Sort as numbers if the property values are numeric
				const numA = parseFloat(a[property]);
				const numB = parseFloat(b[property]);
				return this.sortDirection === 'asc' ? numA - numB : numB - numA;
			} else {
				// Sort as strings if the property values are not numeric
				const comparison = a[property].localeCompare(b[property]);
				return this.sortDirection === 'asc' ? comparison : -comparison;
			}
		});
	}
	
	vouchers(){
		this.loading = true;
		this.educationService.getVoucherReport(this.searchForm.value).subscribe((p: any) => {
			this.loading = false;
			this.reportResults = p;
			this.sortedReportResults= p;
		});
	}
	
	exportPdf() {

		if (!this.printtablepdf) {
		  console.error('Print table element not found');
		  return;
		}
		
		const d = new Date();
		this.sending = true;
		const encoded = this.globalSearchService.base64encode(this.printtablepdf.nativeElement.innerHTML);
		
		const data = {
		  content: encoded,
		  filename: 'voucher_reports',
		  title: `Voucher Report -  ${d.toLocaleString()}`,
		};

	  
		this.printService.pdf(data).subscribe((result: any) => {
		  this.globalSearchService.downloadPdf(result.content, data.filename);
		  this.sending = false;
		});
	  }

	exportXls() {

		if (!this.printtablepdf) {
			console.error('Print table element not found');
			return;
		}
		const d = new Date();
		this.sending = true;
		const encoded = this.globalSearchService.base64encode(this.printtablepdf.nativeElement.innerHTML);

		const data = {
			content: encoded,
			filename: 'voucher_report',
			title: `Voucher Report -  ${d.toLocaleString()}`
		};

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.sending = false;
		});
	}
}
